import { X, FileText, Image as ImageIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FilePreviewProps {
  type: 'image' | 'pdf';
  previewUrl?: string;
  fileName?: string;
  onRemove: () => void;
  className?: string;
}

export function FilePreview({ type, previewUrl, fileName, onRemove, className }: FilePreviewProps) {
  if (type === 'image' && previewUrl) {
    return (
      <div className={cn("relative group", className)}>
        <div className="relative w-24 h-24 rounded-lg overflow-hidden border">
          <img 
            src={previewUrl}
            alt="معاينة"
            className="w-full h-full object-cover"
          />
          <button
            type="button"
            onClick={onRemove}
            className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <X className="h-5 w-5 text-white" />
          </button>
        </div>
      </div>
    );
  }

  if (type === 'pdf') {
    return (
      <div className={cn("relative group", className)}>
        <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border">
          <div className="flex-shrink-0">
            <FileText className="h-6 w-6 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {fileName || 'ملف PDF'}
            </p>
            <p className="text-xs text-gray-500">
              انقر للمعاينة
            </p>
          </div>
          <button
            type="button"
            onClick={onRemove}
            className="flex-shrink-0 p-1 hover:bg-gray-200 rounded-full transition-colors"
          >
            <X className="h-4 w-4 text-gray-500" />
          </button>
        </div>
      </div>
    );
  }

  return null;
}